module.exports = __webpack_public_path__ + "static/img/ctcc.5c1df46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ctcc.png
// module id = UyEh
// module chunks = 40